import ExploreBar from "@bmi-digital/components/explore-bar";
import { graphql } from "gatsby";
import React from "react";
import { useSiteContext } from "./Site";
import { toButtonActionProps } from "./link/utils";
import type { ExternalLinkBlock, InternalLinkBlock } from "./link/types";
import type { ButtonProps } from "@bmi-digital/components/button";
import type { PayloadExploreBarSection } from "../types/payload";

export type ExploreBarData = Pick<PayloadExploreBarSection, "title"> & {
  links: (InternalLinkBlock | ExternalLinkBlock)[];
};

const IntegratedExploreBar = ({ data }: { data: ExploreBarData }) => {
  const { countryCode } = useSiteContext();
  const { title, links } = data;

  return (
    <ExploreBar
      heading={title}
      links={
        links.map<ButtonProps>((link) => ({
          children: link.label,
          ...toButtonActionProps(link, countryCode)
        })) as [ButtonProps, ...ButtonProps[]]
      }
    />
  );
};

export default IntegratedExploreBar;

export const query = graphql`
  fragment ExploreBarFragment on PayloadExploreBarSection {
    title
    links {
      ... on PayloadInternalLinkBlock {
        ...InternalLinkBlockFragment
      }
      ... on PayloadExternalLinkBlock {
        ...ExternalLinkBlockFragment
      }
    }
  }
`;
